import React from 'react';

// Types
import useGroupResizeState, { ElementResizeState, GroupResizeStateProps } from './useGroupResizeState';
import { MaintainAspectRatioMode } from './resizeTypes';

/**
 * Decorator that provides resizing state and actions to a component.
 * To be used along with the `groupResizeBehaviourDecorator` which handles resizing and updates, and the`ResizeHandle` which provides the drag handle and handles the event listeners.
 * Any custom update functionality can be added as a decorator between this one and the `groupResizeBehaviourDecorator`.
 */
export default (
        getShouldMaintainAspectRatio?: (props: GroupResizeStateProps) => MaintainAspectRatioMode,
        minWidth?: number,
        minHeight?: number,
    ) =>
    (
        DecoratedComponent: React.ComponentType<GroupResizeStateProps>,
    ): React.FC<GroupResizeStateProps & ElementResizeState> => {
        return (props: GroupResizeStateProps) => {
            const elementResizeState = useGroupResizeState(props, getShouldMaintainAspectRatio, minWidth, minHeight);
            return <DecoratedComponent {...props} {...elementResizeState} />;
        };
    };
